import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Products from './Dashboard/Products';
import MissingProduct from '../../Elements/MissingProduct';
import ElectricityIcon from '../../../assets/images/icon-electricity.svg';
import WaterIcon from '../../../assets/images/icon-water.svg';
import HeatIcon from '../../../assets/images/icon-heat.svg';
import ContractsIcon from '../../../assets/images/NEVE_Sopimukseni.png';
import InvoicesIcon from '../../../assets/images/NEVE_Laskut.png';
import Loading from '../Shared/Loading';
import LinkBox from './Dashboard/LinkBox';

import { Props, State } from '../../../types/common';
import { ContractType } from '../../../store/index';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { themeDetails } from '../../../theme/theme.ts';
import MessageBox from './Dashboard/MessageBox';

class Dashboard extends Component<Props, State> {
  constructor(props:Props) {
    super(props)
    this.state = {
      districtheatContracts: [],
      electricityContracts: [],
      waterContracts: [],
      errorMessage: '',
      hasData: true,
      loading: false,
      fibreAddressesByType: {},
    }
  }
  componentDidUpdate(): void {
    window.scrollTo(0, 0)
  }

  // TODO Determine type.
  componentDidMount = async (): Promise<any> => { // eslint-disable-line
    const { LoginStore } = this.props

    if (!LoginStore.logged || !LoginStore.customerData || !LoginStore.customerData.length) {
      await LoginStore.login('consumer', true)
    }

    const contracts = LoginStore.customerData[0]?.contracts;
    // Group contracts by usage type
    const electricity: ContractType[] = []
    const districtheat: ContractType[] = []
    const water: ContractType[] = []

    contracts?.forEach(contract => {
      if (contract.contractType === 'Sähköverkkosopimus' || contract.contractType === 'Sähköntuotannon verkkosopimus') {
        electricity.push(contract)
      } else if (contract.contractType === 'Kaukolämmön myyntisopimus') {
        districtheat.push(contract)
      } else if (contract.contractType === 'water') {
        water.push(contract)
      }
    })
    this.setState({
      electricityContracts: electricity,
      districtheatContracts: districtheat,
      waterContracts: water,
      hasData: true,
    })
  }

  render() {
    const {
      hasData,
      electricityContracts,
      waterContracts,
      districtheatContracts,
      errorMessage,
      loading,
    } = this.state

    const { LoginStore } = this.props

    const { services, incomingServices } = themeDetails

    const isProvidedService = (service: string): boolean => { return services.indexOf(service) > -1 }
    const isIncomingService = (service: string): boolean => incomingServices.indexOf(service) > -1

    if (loading || !LoginStore.customerData) {  /* -ADP */
      return <Loading message="Ladataan käyttötietoja..." />
    }

    const infoboksi = LoginStore.getTemplate('infoboksi.html')

    return (
      <div className="wrapper dashboard container">
        <MessageBox />
        <div className="products col-md-6">
          <h1 className="dashboardHeader">Kulutustietoni</h1>

          {errorMessage && <p className="errortext">{errorMessage}</p>}

          {(isIncomingService('electricity') ||
            (
              electricityContracts &&
              electricityContracts.length > 0)) && (
              <Products
                name={'Sähkö'}
                type={'electricity'}
                pathname={'sahko'}
                icon={ElectricityIcon}
                contracts={electricityContracts as ContractType[]}
                duration={600}
                isIncoming={isIncomingService('electricity')}
              />
            )}

          {(isIncomingService('districtheat') ||
            districtheatContracts &&
            districtheatContracts.length > 0) && (
              <Products
                name={'Kaukolämpö'}
                type={'districtheat'}
                pathname={'kaukolampo'}
                icon={HeatIcon}
                contracts={districtheatContracts as ContractType[]}
                duration={800}
                isIncoming={isIncomingService('districtheat')}
              />
            )}

          {(isIncomingService('water') ||
            (isProvidedService('water') &&
              waterContracts &&
              waterContracts.length > 0)) && (
              <Products
                name={'Vesi'}
                type={'water'}
                pathname={'vesi'}
                icon={WaterIcon}
                contracts={waterContracts as ContractType[]}
                duration={700}
                isIncoming={isIncomingService('water')}
                isIncomingMessage="Veden kulutustiedot tulossa palveluun myöhemmin"
              />
            )}

          {!hasData && (
            <MissingProduct
              name={'Ei sopimustietoja'}
              productClass={'missing'}
            />
          )}

          {infoboksi && (
            <div
              className="missing"
              dangerouslySetInnerHTML={{ __html: infoboksi }}
            />
          )}
        </div>
        <div className="services col-md-6">
          {services.some(
            (service: string) => ['billingInfo', 'contractInfo'].indexOf(service) > -1
          ) && <h1 className="dashboardHeader">Asiakkuuteni</h1>}

          {isProvidedService('billingInfo') && (
            <LinkBox
              name={'Laskuni'}
              productClass={'invoices'}
              icon={InvoicesIcon}
              link={'/laskut'}
            />
          )}

          {isProvidedService('contractInfo') && (
            <LinkBox
              name={'Käyttöpaikan tiedot'}
              productClass={'contracts'}
              icon={ContractsIcon}
              link={'/sopimukset'}
            />
          )}
          <LinkBox
            name={'Laskutiedot'}
            productClass={'contracts'}
            icon={ContractsIcon}
            link={'/laskutustiedot'}
          />
        </div>
      </div>
    )
  }
}

export default inject('LoginStore')(observer(Dashboard))
